import { ComponentBase } from '@base';
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { filter, map, takeUntil } from 'rxjs/operators';
import { UserService } from '@services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent extends ComponentBase {
  returnUrl: string;
  loading: boolean = false;

  constructor(
    protected route: ActivatedRoute,
    private router: Router,
    private userService: UserService
  ) {
    super(route);
    this.route.queryParamMap
      .pipe(
        filter((queryParamMap) => queryParamMap.has('returnUrl')),
        map((queryParamMap) => queryParamMap.get('returnUrl'))
      )
      .subscribe((returnUrl) => (this.returnUrl = returnUrl));
  }

  userLoggedIn(firebaseUser) {
    this.loading = true;
    this.userService
      .getById(firebaseUser.uid)
      .pipe(
        filter((user) => !!user),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (user) => {
          this.loading = false;
          if (firebaseUser && this.returnUrl && this.returnUrl !== '') {
            this.router.navigate([this.returnUrl]);
          } else if (user.roles.employee) {
            this.router.navigate(['/admin']);
          }
        },
        error: () => (this.loading = false),
        complete: () => (this.loading = false),
      });
  }
}
